import React, { useEffect, useState, useContext, useRef } from "react";
import { Card } from 'primereact/card';
import { Skeleton } from 'primereact/skeleton';
import { useWeb3React } from "@web3-react/core";
import { TabView, TabPanel } from 'primereact/tabview';
import { Popover, Table, Tooltip as TooltipNext, Button as RevealButton, Progress, Badge } from '@nextui-org/react';
import Web3 from "web3";

import { SelectButton } from 'primereact/selectbutton';

import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Rating } from 'primereact/rating';
import { Message } from 'primereact/message';
import customIcon from "../../imgs/custom-icon.png";
import customIconActive from "../../imgs/custom-icon-active.png"

import ContractContext from '../../ContractContext'; //Required for all dApp components using contracts

import {
    walletCardOutlineStyle, miniCardHeaderStyle, miniInfoStyle, infoStyle,
} from "./TileStyles";

import { formatTokenLabel, formatCurrencyExtended, abbreviateNumber, getTokenPrice, formatWalletAddress, formatPercentage } from '../../utils';

import BigNumber from 'bignumber.js';

import { useInView } from 'react-intersection-observer';

import { DefiAppService } from "../../DefiAppService";

const DashboardModuleWallet = ({ data, getData, bnbBalance }) => {

    const { library, account } = useWeb3React();
    const contractContext = useContext(ContractContext);
    const contracts = contractContext.contracts;
    const isWalletConnected = () => account !== null;

    const toast = useRef(null);

    const LoadingSmallContent = () => <Skeleton width="50%" height="12px" className="mb-2" />;
    const LoadingContent = () => <Skeleton width="50%" height="35px" className="mb-2" />;
    const LoadingTitle = () => <Skeleton width="25%" height="25px" className="mb-2" />;

    const [walletHoldings, setWalletHoldings] = useState(null);


    const tokenCardStyle = (image) => {
        return {
        background: "#333333",
        borderRadius: "20px",
        color: "#FFFFFF",
        marginBottom: "10px",
        fontFamily: 'Inter, sans-serif',
        backgroundImage: `linear-gradient(263deg, rgb(250 202 90 / 85%), rgb(75 75 150 / 50%)), ${image}, linear-gradient(153deg,rgb(0, 0, 0), rgb(0, 0, 0) 19%, rgb(0, 0, 0))`,
        backgroundPosition: '0px 0px, 115% 50%, 0px 0px',
        backgroundSize: 'auto, auto 135%, auto',
        backgroundRepeat: 'repeat, repeat-y, repeat',
        backgroundAttachment: 'scroll, scroll, scroll',
        gridColumn: 'span 2',
        gridRow: 'span 1'
    }};
      

    useEffect(() => {
        //console.log("Wallet walletHoldings:", walletHoldings);
    }, [walletHoldings]);

    const calculateTokenBalanceUSD = (token) => {
        if (!token.price || token.balanceOfHolder <= 0) return 0;
        const calculatedBalance = new BigNumber(token.balanceOfHolder)
            .times(token.price)
            .div(new BigNumber(10).pow(token.decimals))

        return calculatedBalance.isNaN() ? 0 : calculatedBalance.toNumber();
    };

    const calculateTotalWalletBalanceUSD = (tokensListRp) => {
        let totalWallet = new BigNumber(0);

        if (tokensListRp) {
            tokensListRp.forEach(token => {
                if (token.price && (token.balanceOfHolder > 0 || (token.label === "WBNB" && bnbBalance > 0))) {
                    const value = new BigNumber(token.label === "WBNB" ? bnbBalance : token.balanceOfHolder)
                        .times(token.price)
                        .div(new BigNumber(10).pow(token.decimals));

                    if (includeAllTokens || value.toNumber() > 1)
                        totalWallet = totalWallet.plus(value);
                }
            });
        }

        // Convert back to a number, for display
        return totalWallet.isNaN() ? 0 : totalWallet.toNumber();
    };

    const calculateBNBBalanceUSD = (token, bnbBalance) => {
        if (!bnbBalance) return 0;
        const calculatedBalance = new BigNumber(bnbBalance)
            .times(token.price)
            .div(new BigNumber(10).pow(token.decimals))

        return calculatedBalance.isNaN() ? 0 : calculatedBalance.toNumber();
    };


    //toggles


    const options = ['Hide Small Balances', 'View All'];
    const [value, setValue] = useState(options[1]);

    useEffect(() => {
        if (value === options[0]) {
            setIncludeAllTokens(false);
        } else {
            setIncludeAllTokens(true);
        }
    }, [value]);

    const [includeAllTokens, setIncludeAllTokens] = useState(false);



    const options_adv = ['Simple', 'Advanced'];
    const [valueAdv, setValueAdv] = useState(options_adv[0]);

    useEffect(() => {
        if (valueAdv === options_adv[0]) {
            setAdvancedView(false);
        } else {
            setAdvancedView(true);
        }
    }, [valueAdv]);

    const [advancedView, setAdvancedView] = useState(false);



    //trigger when "Advanced View" is clicked

    //const [liquidityData, setLiquidityData] = useState(null);

    const getLiquidityPairs = async (token) => {
        //console.log("fetching token...", token);
        const liquidityOracleData = await contracts.liquidityOracle.methods
            .getLiquidityPairsInfo(token.name)
            .call()
            .then((data) => {
                //console.log("TokenLiquidity.js getLiquidityPairs data:", data);
                return data;
            });

        const liquidityOracleData2 = await contracts.liquidityOracle.methods
            .getLiquidityPairsInfo("0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c", [token.name], false)
            .call()
            .then((data) => {
                //console.log("TokenLiquidity.js getLiquidityPairs WBNB data:", data);
                return data;
            });

        return [...liquidityOracleData, ...liquidityOracleData2];
        //setLiquidityData(combinedData);

        //setLoading(false); 
    };

    // useEffect(() => {
    //     console.log("Wallet liquidityData:", liquidityData);
    // }, [liquidityData]);

    //when advancedView changes and we have walletHoldings, get liquidity pairs  for each and append the result to walletHoldings.liquidityPairs
    useEffect(() => {
        if (walletHoldings && advancedView) {
            // Create a copy of walletHoldings to update
            const updatedWalletHoldings = [...walletHoldings];

            // Use Promise.all to await all asynchronous operations
            Promise.all(
                updatedWalletHoldings.map(async (token, index) => {
                    const liquidityPairs = await getLiquidityPairs(token);
                    updatedWalletHoldings[index].liquidityPairs = liquidityPairs;

                    // Use reduce to accumulate tokenBalanceInLiquidityPair values
                    const tokenBalanceSum = liquidityPairs.reduce((sum, pair) => {
                        if (pair.backingToken === token.name) {
                            const tokenBalanceInLiquidityPair = new BigNumber(pair.backingTokenBalanceInLiquidityPair);
                            //console.log("tokenBalanceInLiquidityPair:", tokenBalanceInLiquidityPair);
                            // Use plus and return the sum in each iteration
                            return sum.plus(tokenBalanceInLiquidityPair);
                        }
                        return sum;
                    }, new BigNumber(0)); // Initialize sum with 0

                    const totalSupply = new BigNumber(token.totalSupply);
                    const liquidityBacking = tokenBalanceSum.div(totalSupply).times(2);
                    //console.log("liquidity backing:", liquidityBacking.toNumber());

                    // Assign the calculated liquidityBacking to the token
                    updatedWalletHoldings[index].liquidityBacking = liquidityBacking.toNumber();
                    const marketCap = new BigNumber(token.totalSupply).div(new BigNumber(10).pow(token.decimals)).times(token.price).toNumber();
                    const liquidityHealth = calculateLiquidityHealthScore(marketCap, liquidityBacking.times(100).toNumber());
                    updatedWalletHoldings[index].liquidityHealthScore = liquidityHealth.score;
                    updatedWalletHoldings[index].liquidityHealthRating = liquidityHealth.rating;

                })
            ).then(() => {
                // Update the state with the updated array
                setWalletHoldings(updatedWalletHoldings);
                //console.log("Wallet walletHoldings after fetch:", updatedWalletHoldings);
            });
        }
    }, [advancedView, includeAllTokens]);



    useEffect(() => {
        //console.log("Wallet walletHoldings:", walletHoldings);
    }, [walletHoldings]);

    useEffect(() => {
        //console.log("data:", data);
        if (data.tokensListRp && bnbBalance && includeAllTokens !== undefined)
            setWalletHoldings(
                data.tokensListRp
                    .map(token => ({
                        name: token.value,
                        symbol: token.label,
                        totalSupply: token.totalSupply,
                        decimals: token.decimals,
                        price: token.price,
                        balanceOfHolder: token.balanceOfHolder,
                        balanceUSD: token.label === "WBNB" ?
                            //override t
                            calculateBNBBalanceUSD(token, bnbBalance)
                            : calculateTokenBalanceUSD(token)
                    }))
                    .sort((a, b) => b.balanceUSD - a.balanceUSD)
                    .filter((token) => token.balanceUSD > (includeAllTokens ? 0.009 : 1))
            );
    }, [data, value, bnbBalance, includeAllTokens]);

    const exclusions = ["0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c".toLowerCase(),
    "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56".toLowerCase(),
    "0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE".toLowerCase(),
    "0x3EE2200Efb3400fAbB9AacF31297cBdD1d435D47".toLowerCase(),
    "0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c".toLowerCase(),
    "0x2170Ed0880ac9A755fd29B2688956BD959F933F8".toLowerCase(),
    "0x7083609fce4d1d8dc0c979aab8c869ea2c873402".toLowerCase(),
    "0x2859e4544C4bB03966803b044A93563Bd2D0DD4D".toLowerCase(),
    "0xbA2aE424d960c26247Dd6c32edC70B295c744C43".toLowerCase(),
    "0x570a5d26f7765ecb712c0924e4de545b89fd43df".toLowerCase(),
    "0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82".toLowerCase(),
    "0x156ab3346823b651294766e23e6cf87254d68962".toLowerCase(),
    "0x6fdcdfef7c496407ccb0cec90f9c5aaa1cc8d888".toLowerCase(),
    "0xbE5243FE96888114455997eC129c25B2D10aB8fD".toLowerCase(),
    "0xCC42724C6683B7E57334c4E856f4c9965ED682bD".toLowerCase(),
    "0x324E8E649A6A3dF817F97CdDBED2b746b62553dD".toLowerCase(),
    "0x56b6fB708fC5732DEC1Afc8D8556423A2EDcCbD6".toLowerCase(),
    "0x55d398326f99059ff775485246999027b3197955".toLowerCase(),]


    // const calculateLiquidityHealthScore = (marketCap, liquidityBacking) => {
    //     const liquidityCap = marketCap * (liquidityBacking / 100);  // calculating the liquidity-cap value

    //     const thresholds = [
    //         { marketCap: 50000000000, minLiquidity: 5 },
    //         { marketCap: 25000000000, minLiquidity: 6},
    //         { marketCap: 10000000000, minLiquidity: 6 },
    //         { marketCap: 5000000000, minLiquidity: 7 },
    //         { marketCap: 2500000000, minLiquidity: 8},
    //         { marketCap: 1000000000, minLiquidity: 8 },
    //         { marketCap: 500000000, minLiquidity: 8 },
    //         { marketCap: 250000000, minLiquidity: 9},
    //         { marketCap: 100000000, minLiquidity: 9 },
    //         { marketCap: 50000000, minLiquidity: 10 },
    //         { marketCap: 25000000, minLiquidity: 15 },
    //         { marketCap: 5000000, minLiquidity: 20 },
    //         { marketCap: 1000000, minLiquidity: 25 },
    //         { marketCap: 500000, minLiquidity: 35 },
    //         { marketCap: 250000, minLiquidity: 45 },
    //         { marketCap: 100000, minLiquidity: 55 },
    //         { marketCap: 50000, minLiquidity: 65 },
    //         { marketCap: 25000, minLiquidity: 75 },
    //         { marketCap: 10000, minLiquidity: 85 },
    //         { marketCap: 5000, minLiquidity: 95 },
    //         { marketCap: 1000, minLiquidity: 98 },
    //         { marketCap: 100, minLiquidity: 99 }
    //     ];

    //     for (const threshold of thresholds) {
    //         if (marketCap >= threshold.marketCap) {
    //             if (liquidityBacking >= threshold.minLiquidity) {
    //                 return { score: 100, rating: 5 };  // Top score and top rating
    //             } else {
    //                 return { score: (liquidityBacking / threshold.minLiquidity) * 100, rating: Math.ceil((liquidityBacking / threshold.minLiquidity) * 5) };
    //             }
    //         }
    //     }

    //     return { score: 0, rating: 0 }; // If market cap is too low
    // };



    const calculateLiquidityHealthScore = (marketCap, liquidityBacking) => {
        const liquidityCap = marketCap * (liquidityBacking / 100);  // calculating the liquidity-cap value

        const thresholds = [
            { marketCap: 50000000000, minLiquidity: 5 },
            { marketCap: 25000000000, minLiquidity: 6 },
            { marketCap: 10000000000, minLiquidity: 7 },
            { marketCap: 5000000000, minLiquidity: 10 },
            { marketCap: 2500000000, minLiquidity: 12 },
            { marketCap: 1000000000, minLiquidity: 15 },
            { marketCap: 500000000, minLiquidity: 20 },
            { marketCap: 250000000, minLiquidity: 25 },
            { marketCap: 100000000, minLiquidity: 30 },
            { marketCap: 50000000, minLiquidity: 34 },
            { marketCap: 25000000, minLiquidity: 37 },
            { marketCap: 5000000, minLiquidity: 40 },
            { marketCap: 1000000, minLiquidity: 42 },
            { marketCap: 500000, minLiquidity: 45 },
            { marketCap: 250000, minLiquidity: 50 },
            { marketCap: 100000, minLiquidity: 60 },
            { marketCap: 50000, minLiquidity: 68 },
            { marketCap: 25000, minLiquidity: 75 },
            { marketCap: 10000, minLiquidity: 83 },
            { marketCap: 5000, minLiquidity: 88 },
            { marketCap: 1000, minLiquidity: 93 },
            { marketCap: 100, minLiquidity: 99 }
        ];

        for (const threshold of thresholds) {
            if (marketCap >= threshold.marketCap) {
                if (liquidityBacking >= threshold.minLiquidity) {
                    return { score: 100, rating: 5 };  // Top score and top rating
                } else {
                    return { score: (liquidityBacking / threshold.minLiquidity) * 100, rating: Math.ceil((liquidityBacking / threshold.minLiquidity) * 5) };
                }
            }
        }

        return { score: 0, rating: 0 }; // If market cap is too low
    };


    const determineColor = (rating) => {
        switch (rating) {
            case 1:
                return "danger";
            case 2:
                return "warning";
            case 3:
                return "success";
            case 4:
                return "success";
            case 5:
                return "success";
            default:
                return "danger";
        }
    };


    return (
       <>
            <div style={{ marginTop: "10px" }}>
                <>



                    <div>
                        <div style={{ marginTop: "15px" }}>
                            Total Value
                        </div>
                        <div style={infoStyle}>
                            {data?.tokensListRp !== undefined
                                ? formatCurrencyExtended(calculateTotalWalletBalanceUSD(data.tokensListRp))
                                : LoadingContent()
                            }
                        </div>
                    </div>

                    <div>
                        <SelectButton value={value} onChange={(e) => setValue(e.value)} options={options}
                            style={{ width: '100%', justifyContent: 'center', marginTop: '10px' }} />
                    </div>
                    <div>
                        <SelectButton value={valueAdv} onChange={(e) => setValueAdv(e.value)} options={options_adv}
                            style={{ width: '100%', justifyContent: 'center', marginTop: '10px', marginBottom: '10px' }} />
                    </div>

                    {advancedView &&
                        <Message severity="info" text="Currently only V2 LP Pools are being used for Liquidity Score (Currently in Alpha)" />
                    }

                    <div style={{ ...miniCardHeaderStyle, marginTop: "20px" }}>
                        Listed Tokens
                    </div>

                    {/* <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(115px, 1fr))', gap: '12px', marginTop: '10px' }}> */}
                    <div style={{
                        flexDirection: 'column', display: 'grid', flexWrap: 'wrap',
                        gridTemplateColumns: advancedView ? 'repeat(auto-fill, minmax(100%, 1fr))' : 'repeat(auto-fill, minmax(115px, 1fr))',
                        justifyContent: 'flex-start', gap: '12px', marginTop: '10px',
                    }}>
                        {walletHoldings ?
                            walletHoldings
                                .map((token, index) => (
                                    <div key={index} style={{
                                        flexDirection: advancedView ? 'column' : 'row',
                                    }}>
                                        <div style={{
                                            ...miniInfoStyle, display: 'flex',
                                            flexDirection: advancedView ? 'row' : 'column',
                                            justifyContent: advancedView ? 'space-between' : 'flex-start',
                                            borderRadius: '20px',
                                            border: advancedView ? '1px solid #2b343b' : 'none',
                                            padding: advancedView ? '8px' : '0px',
                                            // backgroundColor: advancedView ? '#171e1f' : 'transparent',
                                            
                                            backgroundImage: advancedView ? `linear-gradient(263deg, rgb(10 10 10 / 98%), rgb(25 35 40 / 90%)), url(${
                                                data?.dbData?.find((tokenData) => tokenData.address.toLowerCase() === token.name.toLowerCase()).logo?.url
                                                }), linear-gradient(153deg,rgb(5 5 5 / 95%), rgb(0, 0, 0) 50%, rgb(0, 0, 0))` : 'none',
                                            backgroundPosition:  advancedView ? '0px 0px, 115% 50%, 0px 0px' : 'none',
                                            //backgroundSize: 'auto 100%, auto 135%, auto',
                                            //static background size instead
                                            backgroundSize:  advancedView ?' auto, auto, 50% auto': '',
                                            backgroundRepeat:  advancedView ? 'repeat, repeat-y, repeat': 'none',
                                        }}>
                                            <div>
                                                <div style={{
                                                    padding: '5px 10px 5px 10px',
                                                    flexDirection: 'column',
                                                    display: 'flex',
                                                }}>
                                                    <div>
                                                        <div style={{
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                        }}>
                                                            {formatTokenLabel(data.dbData, { value: token.name, })}
                                                            {formatCurrencyExtended(token.balanceUSD)}
                                                        </div>
                                                        <div style={{
                                                            fontSize: advancedView ? '16px' : '12px',
                                                            marginTop: '2px',
                                                            color: 'white',
                                                            fontWeight: '100',
                                                            //marginLeft: '5px',
                                                            //increase letter spacing
                                                            letterSpacing: '2px',
                                                        }}>
                                                            <strong >{token.symbol === "WBNB" ? "BNB" : token.symbol}</strong> 
                                                        </div>
                                                    </div>
                                                    <div>
                                                        {advancedView && token.liquidityHealthRating < 2 && !exclusions.includes(token.name.toLowerCase()) &&
                                                            <div style={{
                                                                marginTop: '5px'
                                                            }}>
                                                                <Badge disableOutline color="warning">Dynamic</Badge>
                                                            </div>
                                                        }
                                                    </div>

                                                </div>
                                                {advancedView &&
                                                    <div style={{
                                                        alignSelf: 'flex-end',
                                                        justifyContent: 'flex-start',
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        marginTop: '5px',
                                                        marginBottom: '5px',
                                                    }}>

                                                        <Button icon="pi pi-copy" size="small" text rounded onClick={() => {
                                                            navigator.clipboard.writeText(token.name);
                                                            toast.current.show({
                                                                severity: 'success',
                                                                summary: 'Copied to clipboard',
                                                                detail: token.name,
                                                                life: 3000
                                                            });
                                                        }}
                                                            style={{
                                                                padding: '0px 5px 0px 5px',
                                                                margins: '0px',
                                                            }}
                                                            label={formatWalletAddress(token.name)}
                                                            severity="secondary"
                                                        />

                                                        <Button icon="pi pi-chart-line" size="small" text rounded onClick={() => {
                                                            //open navigation to https://poocoin.app/tokens/tokenAddress
                                                            window.open("https://poocoin.app/tokens/" + token.name, "_blank");
                                                        }}
                                                            style={{
                                                                padding: '0px 5px 0px 5px',
                                                                margins: '0px',
                                                            }}
                                                            label="Chart"
                                                            severity="secondary"
                                                        />
                                                    </div>
                                                }
                                                {advancedView && !exclusions.includes(token.name.toLowerCase()) &&
                                                    <div style={{
                                                        borderRadius: '15px',
                                                        backgroundColor: 'black',
                                                        padding: '5px 10px 5px 10px',
                                                        marginTop: '5px',

                                                    }}>

                                                        <div style={{
                                                            fontSize: '10px',
                                                            marginTop: '2px',
                                                            color: 'white',
                                                            fontWeight: '200',
                                                            //marginLeft: '5px',
                                                            //increase letter spacing
                                                            letterSpacing: '2px',
                                                            marginBottom: '5px',
                                                        }}>
                                                            Liquidity Score: {
                                                                //token.liquidityHealthScore to 2 decimals
                                                                token.liquidityHealthScore ? <strong> {token.liquidityHealthScore.toFixed(0)} </strong> : LoadingSmallContent()
                                                            }
                                                        </div>
                                                        {/* <Progress color={determineColor(token.liquidityHealthRating)} size="xs" value={token.liquidityHealthScore} /> */}
                                                        {/* <Progress color={determineColor(token.liquidityHealthRating)} size="xs" value={token.liquidityHealthRating * 20} />
                                                        <Progress color={determineColor(token.liquidityHealthRating)} size="xs" value={token.liquidityHealthScore} /> */}
                                                        {/* <Rating value={token.liquidityHealthRating} readOnly cancel={false} /> */}
                                                        <Rating value={token.liquidityHealthRating} readOnly cancel={false}
                                                            onIcon={<img src={customIconActive} width="18px" height="18px" />}
                                                            offIcon={<img src={customIcon} width="18px" height="18px" />}
                                                            style={{ display: 'inline-flex' }}
                                                        />

                                                    </div>
                                                }


                                            </div>
                                            <div
                                                style={{
                                                    textAlign: 'right',
                                                }}
                                            >
                                                {advancedView &&
                                                    <div style={{
                                                        marginBottom: '5px',
                                                        padding: '5px 0px 5px 0px',
                                                    }}>
                                                        <div style={{
                                                            fontSize: '9px',
                                                            marginTop: '2px',
                                                            //color: 'grey',
                                                            fontWeight: '200',
                                                            //marginLeft: '5px',
                                                            //increase letter spacing
                                                            letterSpacing: '2px',
                                                        }}>
                                                            {/* {token.symbol === "WBNB" ? "BNB" : token.symbol}  */}
                                                            Balance
                                                        </div>

                                                        {token.balanceOfHolder !== undefined ?
                                                            token.symbol === "WBNB" ?
                                                                abbreviateNumber(
                                                                    new BigNumber(bnbBalance)
                                                                        .div(new BigNumber(10).pow(token.decimals)).toNumber()
                                                                )
                                                                :
                                                                abbreviateNumber(
                                                                    new BigNumber(token.balanceOfHolder).div(new BigNumber(10).pow(token.decimals)).toNumber()
                                                                ) : LoadingSmallContent()}
                                                    </div>
                                                }

                                                {advancedView && !exclusions.includes(token.name.toLowerCase()) &&
                                                    <>
                                                        <div style={{
                                                            fontSize: '9px',
                                                            marginTop: '2px',
                                                            color: 'grey',
                                                            fontWeight: '200',
                                                            //marginLeft: '5px',
                                                            //increase letter spacing
                                                            letterSpacing: '1px',
                                                        }}>
                                                            Liquidity Backing:{token.liquidityBacking ?
                                                                <div style={{
                                                                    fontSize: '10px',
                                                                    color: 'white',
                                                                    fontWeight: '400',
                                                                    //marginLeft: '5px',
                                                                    //increase letter spacing
                                                                    letterSpacing: '2px',
                                                                }}>
                                                                    {formatPercentage(token.liquidityBacking)}
                                                                </div>
                                                                : LoadingSmallContent()}
                                                        </div>
                                                        <div style={{
                                                            fontSize: '9px',
                                                            marginTop: '2px',
                                                            color: 'grey',
                                                            fontWeight: '200',
                                                            //marginLeft: '5px',
                                                            //increase letter spacing
                                                            letterSpacing: '1px',
                                                        }}>
                                                            Liquidity Value: {token.liquidityBacking ?
                                                                <div style={{
                                                                    fontSize: '10px',
                                                                    color: 'white',
                                                                    fontWeight: '400',
                                                                    //marginLeft: '5px',
                                                                    //increase letter spacing
                                                                    letterSpacing: '2px',
                                                                }}>
                                                                    ${abbreviateNumber(new BigNumber(token.totalSupply).div(new BigNumber(10).pow(token.decimals)).times(token.price).toNumber() * token.liquidityBacking)}
                                                                </div>
                                                                : LoadingSmallContent()
                                                            }
                                                        </div>


                                                        {/* <div style={{
                                                fontSize: '9px',
                                                marginTop: '2px',
                                                //color: 'grey',
                                                fontWeight: '200',
                                                //marginLeft: '5px',
                                                //increase letter spacing
                                                letterSpacing: '2px',
                                            }}>
                                                Market Cap: ${
                                                    token.totalSupply !== undefined ? abbreviateNumber(new BigNumber(token.totalSupply).div(new BigNumber(10).pow(token.decimals)).times(token.price).toNumber()) : LoadingSmallContent()
                                                }
                                            </div> */}

                                                    </>
                                                }
                                                {advancedView && <>
                                                    <div style={{
                                                        fontSize: '9px',
                                                        marginTop: '2px',
                                                        color: 'grey',
                                                        fontWeight: '200',
                                                        //marginLeft: '5px',
                                                        //increase letter spacing
                                                        letterSpacing: '1px',
                                                    }}>
                                                        BSC Market Cap: {
                                                            token.totalSupply !== undefined ?
                                                                <div style={{
                                                                    fontSize: '10px',
                                                                    color: 'white',
                                                                    fontWeight: '400',
                                                                    //marginLeft: '5px',
                                                                    //increase letter spacing
                                                                    letterSpacing: '2px',
                                                                }}>
                                                                    ${abbreviateNumber(new BigNumber(token.totalSupply).div(new BigNumber(10).pow(token.decimals)).times(token.price).toNumber())}
                                                                </div>
                                                                : LoadingSmallContent()
                                                        }
                                                    </div>
                                                    <div style={{
                                                        fontSize: '9px',
                                                        marginTop: '2px',
                                                        color: 'grey',
                                                        fontWeight: '200',
                                                        //marginLeft: '5px',
                                                        //increase letter spacing
                                                        letterSpacing: '1px',
                                                    }}>
                                                        Price: {
                                                            token.price !== undefined ?
                                                                <div style={{
                                                                    fontSize: '10px',
                                                                    color: 'white',
                                                                    fontWeight: '400',
                                                                    //marginLeft: '5px',
                                                                    //increase letter spacing
                                                                    letterSpacing: '2px',
                                                                }}>
                                                                    ${abbreviateNumber(token.price)}
                                                                </div>
                                                                : LoadingSmallContent()
                                                        }
                                                    </div>
                                                </>
                                                }




                                            </div>

                                        </div>

                                    </div>
                                ))
                            :
                            LoadingContent()
                        }
                    </div>
                </>
            </div>
            <Toast ref={toast} />
        </>
    );
}

export default DashboardModuleWallet;
